module.exports = __webpack_public_path__ + "img/portrait-expressive-young-woman 3.09dfe29d.png";